import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useParams } from 'react-router-dom'
import API from '../../../../services/API'
import Avatar from '@mui/material/Avatar'
import LinearProgress from '@mui/material/LinearProgress'
import Link from '@mui/material/Link'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import DetailsBox, { DetailRow } from '../../../../components/Cards/DetailsBox'
import { Box, Grid } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import Attachments from '../../../../components/Attachments/Attachments'

const VDIReport = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [VDI, setVDI] = useState({})

  useEffect(() => {
    API.get(`/fleet/completed-vdis/${id}`)
      .then((res) => res.status === 200 && setVDI(res.data))
      .catch((e) => console.log(e))
      .finally(() => setLoading(false))
  }, [id])

  return (
    <>
      {loading ? (
        <LinearProgress />
      ) : (
        <Stack gap={1}>
          <DetailsBox mainTitle title="VDI Report">
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={4}>
                  <DetailRow label="Vehicle">
                    <Link href={`/fleet/${VDI.vehicle._id}`} target="_blank">
                      {VDI.vehicle.callSign}
                    </Link>
                  </DetailRow>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <DetailRow
                    label="Completed"
                    value={moment(VDI.date).format('Do MMM YYYY HH:mm')}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <DetailRow label="Completed By">
                    <Link
                      href={`/employees/${VDI.completedBy._id}`}
                      target="_blank"
                    >
                      <Stack direction="row" gap={1} alignItems="center">
                        <Avatar
                          src={VDI.completedBy.photograph}
                          sx={{ height: 20, width: 20, borderRadius: 1 }}
                        />
                        <>
                          {VDI.completedBy.firstName} {VDI.completedBy.lastName}
                        </>
                      </Stack>
                    </Link>
                  </DetailRow>
                </Grid>
                <Grid item xs={12} md={6}>
                  <DetailRow label="Fuel Amount" value={VDI.fuelAmount} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <DetailRow label="Mileage" value={VDI.mileage} />
                </Grid>
              </Grid>
            </Box>
          </DetailsBox>
          <Stack gap={1} padding={1}>
            {Object.keys(VDI?.checks ?? []).map((category, index) => {
              return (
                <DetailsBox key={index} title={category}>
                  <Box padding={1}>
                    <Grid container spacing={1}>
                      {(VDI?.checks[category] ?? []).map((item, index) => (
                        <Grid item xs={12} md={6} lg={4} key={index}>
                          <Box
                            border="solid 2px"
                            sx={{
                              borderColor: item.value
                                ? 'anGreen.main'
                                : 'anRed.main',
                            }}
                            borderRadius={1}
                            display="flex"
                            padding={1}
                            alignItems="center"
                            gap={1}
                          >
                            {item.value ? (
                              <CheckCircleIcon color="success" />
                            ) : (
                              <ErrorIcon color="error" />
                            )}
                            <Stack>
                              <Typography variant="title2" fontSize="1rem">
                                {item.title}
                              </Typography>
                              <Typography fontSize="0.75rem">
                                {item.standard}
                              </Typography>
                            </Stack>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </DetailsBox>
              )
            })}
          </Stack>
          <DetailsBox title="Attachments" component={Paper} padding={1}>
            <Attachments
              existingAttachments={VDI?.attachments ?? []}
              hideTitle
            />
          </DetailsBox>
          <DetailsBox title="Notes" component={Paper} padding={1}>
            <DetailRow
              label="Has something wrong"
              value={VDI.somethingWrong ? 'Yes' : 'No'}
              fullWidthLabel
            />
            {VDI.somethingWrong && (
              <DetailRow
                label="Vehicle Useable"
                value={VDI.vehicleUseable ? 'Yes' : 'No'}
                fullWidthLabel
              />
            )}
            {VDI.somethingWrong && (
              <DetailRow
                label="Defect Reported"
                value={VDI.defectReportRequired ? 'Yes' : 'No'}
                fullWidthLabel
              />
            )}
            {VDI.defect && (
              <DetailRow label="Defect" fullWidthLabel>
                <Link href={`/defects/${VDI.defect._id}`} target="_blank">
                  Click to View
                </Link>
              </DetailRow>
            )}
            <DetailRow label="Notes" value={VDI.notes} />
          </DetailsBox>
        </Stack>
      )}
    </>
  )
}

export default VDIReport
